module.exports = __webpack_public_path__ + "img/girl.d8caed48.png";